module.exports = __webpack_public_path__ + "static/img/sp14.b7c87f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sp14.jpg
// module id = MneF
// module chunks = 0